import routerUtil from "./routerUtil";
import paramUtil from "./paramUtil";

const install = function(Vue) {
    Vue.$routerUtil = Vue.prototype.$routerUtil = routerUtil;
    Vue.$paramUtil = Vue.prototype.$paramUtil = paramUtil
};

export default {
    install
}